<template>
  <div class="lb">
    <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope42',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '基本柱状图-scope42',
      timer: null,
      defaultdata: [
        {
          value1: "一季度",
          value2: "80",
          value3: "系列一",
          value4: "60",
          value5: "系列二",
          value6: '元'
        },
        {
          value1: "二季度",
          value2: "40",
          value3: "系列一",
          value4: "40",
          value5: "系列二",
        },
        {
          value1: "三季度",
          value2: "62",
          value3: "系列一",
          value4: "70",
          value5: "系列二",
        },
        {
          value1: "四季度",
          value2: "90",
          value3: "系列一",
          value4: "20",
          value5: "系列二",
        },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "柱状图数值1", key: "value2" },
        { name: "柱状图图例1", key: "value3" },
        { name: "柱状图数值2", key: "value4" },
        { name: "柱状图图例2", key: "value5" },
        { name: "单位", key: "value6" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let legend = [];
      let unit = this.defaultdata[0].value6
      this.defaultdata.forEach((item, i) => {
        if (item.value2 && item.value3) {
          const vdata1 = { name: item.value3, value: item.value2 };
          data1.push(vdata1);
        }
        if (item.value4 && item.value5) {
          const vdata2 = { name: item.value5, value: item.value4 };
          data2.push(vdata2);
        }

        if (i == 0) {
          if (item.value3) {
            legend.push({
              top: "2%",
              right: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [{ name: item.value3, icon: "rect" }],
            });
          }
          if (item.value5) {
            legend.push({
              top: "2%",
              left: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [{ name: item.value5, icon: "rect" }],
            });
          }
        }
      });
      const xAxis = this.defaultdata.map((item) => {
        return item.value1;
      });
      const percent = (7 / xAxis.length) * 100;
      let zoom = [
        {
          id: "scope42", // 唯一的id
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        title: [
          {
            text: unit,
            top: "0",
            left: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          // trigger: "axis",
          // axisPointer: {
          //   // type: "cross",
          //   crossStyle: {
          //     color: "#999",
          //   },
          // },
        },
        // legend: [
        //   {
        //     top: "2%",
        //     right: 120,
        //     itemHeight: 12, //图例的高度  文字左边那个
        //     itemWidth: 10,
        //     icon: "rect",
        //     textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },

        //     data: ["系列一"],
        //   },
        //   {
        //     top: "2%",
        //     right: 40,
        //     itemWidth: 12,
        //     itemHeight: 10,
        //     icon: "rect",
        //     textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
        //     data: ["系列二"],
        //   },
        // ],
        legend: [...legend],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "0px",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.defaultdata.map((item) => item.value1),
          // boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#4792e9",
              // width: 3,
            },
          },
          axisLabel: {
            interval: 0,
            width: 50,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            formatter: function (value) {
              return value
            },
          },
        },

        yAxis: {
          // type: 'value',
          // min: 0, // 设置y轴刻度的最小值
          // max: 20,  // 设置y轴刻度的最大值
          splitNumber: 4, // 设置y轴刻度间隔个数
          axisLabel: {
            textStyle: {
              color: "#979AA0", // 这里将 x 轴文本颜色设为灰白色
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
        },
        series: [
          {
            data: data1,
            type: "bar",
            name: this.defaultdata[0].value3 || "",

            barWidth: 15,
            barGap: "40%",
            label: {
              normal: {
                show: false,
                position: "top",
                color: "#fff",
              },
              show: true,
            },

            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#0182fc", // 0% 处的颜色
                  },
                  {
                    offset: 0.8,
                    color: "#0182fc", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#08315f", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
          {
            data: data2,
            type: "bar",
            name: this.defaultdata[0].value5 || "",
            barWidth: 15,
            label: {
              normal: {
                show: false,
                position: "top",
                color: "#fff",
              },
              show: true,
            },
            barGap: "40%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#00e3e2", // 0% 处的颜色
                  },
                  {
                    offset: 0.8,
                    color: "#00cbcc", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#023742", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
        ],
        dataZoom: xAxis.length > 7 ? zoom : [],
      };

      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>